// extracted by mini-css-extract-plugin
module.exports = {"toggle":"styles__toggle___3QM-L","header":"styles__header___evb2j","title":"styles__title___14U4n"};